import GlobalModalType from '../types/GlobalModalType';

const initialState = {
  options: {},
  modalComponent: null,
};

// eslint-disable-next-line import/prefer-default-export
export const GlobalModal = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case GlobalModalType.actions.showModal:
      return {
        options: { ...payload.options, isOpen: true },
        modalComponent: payload.modalComponent,
      };

    case GlobalModalType.actions.hideModal:
      return initialState;

    default:
      return state;
  }
};

export const getGlobalModal = (state) => state.GlobalModal;
